export enum EIPv6Status {
    enabled = 1,
    disabled,
    error
}

export interface IPv6State {
    status: EIPv6Status,
    subnet: string,
}

export type ResponseDto = IPv6State[];
